import Vue from 'vue'
import VueMaterial from 'vue-material'
import store from './store'
import router from './router'
import App from './App'
import vuetify from './plugins/vuetify';
import "./plugins/vuetify-money.js";
import resizableColumns from "./directives/resizableColumns";
import uppercase from "./directives/uppercase";
import "./assets/resizable-columns.css";
import "./components/Compras/MapaCotacao/mapaCotacaoZoom.css";

import './plugins/base'
import './plugins/chartist'

import 'vue-material/dist/vue-material.min.css'
import VueTheMask from 'vue-the-mask'
import VueSimpleAlert from "vue-simple-alert";
//import money from 'v-money'

import IdleVue from "idle-vue";

//import {Tabs, Tab} from 'vue-tabs-component';
//import JwPagination from 'jw-vue-pagination';

import VueModal from '@kouts/vue-modal';
import '@kouts/vue-modal/dist/vue-modal.css';


//Vue.component('tabs', Tabs);
//Vue.component('tab', Tab);
//Vue.component('jw-pagination', JwPagination);

Vue.component('Modal', VueModal);
Vue.directive("resizable-columns", resizableColumns);
Vue.directive("uppercase", uppercase);

Vue.use(VueMaterial);
Vue.config.productionTip = false;
Vue.use(VueTheMask);
Vue.use(VueSimpleAlert);
// register directive v-money and component <money>
//Vue.use(money, {precision: 4})

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 2 * 60 * 60 * 1000, // 2 horas (10 * 60 * 1000, // 10 minutos)
  startAtIdle: false
});

new Vue({
  'Modal': VueModal,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
